import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Badge } from '@onward-delivery/design/badge';

import { colors } from '@/styles';
import * as typography from '@/styles/typography';

export const Circle = styled.div`
    width: 15px;
    height: 15px;
    border-radius: 999px;
`;

export const PageTitle = styled.span`
    ${typography.sansSerif}

    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
`;

export const Header1 = styled.span`
    ${typography.sansSerif}

    font-size: 14px;
    font-weight: 800;
    line-height: 27px;
`;

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
`;

export const SectionLabel = styled.span`
    ${typography.sansSerif}

    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${colors.greys.secondary};
`;

const STATUS_BADGE_TONES = {
    neutral: 'border-border bg-muted/10 text-muted',
    success: 'border-primary bg-primary/10 text-primary',
    warning: 'border-warning bg-warning/10 text-warning-fg',
    danger: 'border-destructive/50 bg-destructive/5 text-destructive',
};

// The wrapper must stay bare: `.onward-design .px-2` matches descendants only.
export const StatusBadge = ({ tone = 'neutral', dot = false, children, ...rest }) => (
    <span className="onward-design">
        <Badge
            className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2 py-0 text-[11px] leading-4 ${STATUS_BADGE_TONES[tone]}`}
            {...rest}
        >
            {dot ? <span className="h-1.5 w-1.5 rounded-full bg-current" /> : null}
            {children}
        </Badge>
    </span>
);
